module.exports = __webpack_public_path__ + "img/mobile/Prompts-gameintro/288title@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Prompts-gameintro/288title@3x.png
// module id = 207
// module chunks = 0